// @flow

import * as React from 'react';
import i18n from 'app/common/lib/i18n';
import { Box, Button, Divider, Text } from 'gestalt';

type Props = {
  cancelButtonLabel?: string,
  confirmButtonLabel: string,
  heading?: string,
  message: string,
  onCancel: () => void,
  onConfirm: () => void,
};

export default function BoardEditConfirmation({
  cancelButtonLabel,
  confirmButtonLabel,
  heading,
  message,
  onCancel,
  onConfirm,
}: Props) {
  return (
    <form className="standardForm">
      <Box paddingX={12} paddingY={4}>
        <Text align="center" size="xl" weight="bold">
          {heading || i18n._('Are you sure?')}
        </Text>
      </Box>
      <Divider />
      <div className="body">
        <Text>{message}</Text>
      </div>
      <div>
        <Divider />
        <Box display="flex" justifyContent="end" paddingX={5} paddingY={3}>
          <Box data-test-id="confirmBoardDelete" display="inlineBlock" marginRight={2}>
            <Button inline onClick={onCancel} text={cancelButtonLabel || i18n._('Cancel')} />
          </Box>
          <Box display="inlineBlock">
            <Button inline onClick={onConfirm} text={confirmButtonLabel} color="red" />
          </Box>
        </Box>
      </div>
    </form>
  );
}
